import { Navigate, Outlet, Route } from "react-router-dom";

import { App } from "@/App";
import { PartnerLoginRedirect } from "@/apps/partner/router/PartnerLoginRedirect";
import { AddDevice } from "@/apps/partner/views/AddDevice/AddDevice";
import PartnerDashboard from "@/apps/partner/views/Dashboard/PartnerDashboard";
import { WelcomePartnerPortal } from "@/apps/partner/views/Login/WelcomePartnerPortal";
import { PartnerPortal } from "@/apps/partner/views/PartnerPortal/PartnerPortal";
import Success from "@/apps/partner/views/Success/Success";
import Summary from "@/apps/partner/views/Summary/Summary";
import { WelcomeLoadingSpinner } from "@/components/Welcome/WelcomeLoadingSpinner";
import { ProtectedRoute } from "@/router/ProtectedRoute";

export const partnerRoutes = [
  <Route
    key="partnerBaseRoute"
    path="/partner"
    element={
      <ProtectedRoute user="partner">
        <App />
      </ProtectedRoute>
    }
  >
    <Route index element={<Navigate to="/partner/cockpit" replace />} />
    <Route element={<PartnerDashboard />}>
      <Route path="cockpit" element={<PartnerPortal />} />
      <Route path="add-sim" element={<AddDevice />} />
      <Route path="add-sim/summary" element={<Summary />} />
      <Route path="add-sim/success" element={<Success />} />
    </Route>
  </Route>,

  <Route
    key="partner-welcome-base"
    element={
      <PartnerLoginRedirect>
        <Outlet />
      </PartnerLoginRedirect>
    }
  >
    <Route
      key="welcome-partner"
      path="/welcome-partner"
      element={<WelcomePartnerPortal />}
    />
    <Route
      key="welcome-partner-loading"
      path="/welcome-partner/loading"
      element={<WelcomeLoadingSpinner />}
    />
  </Route>,
];
